<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-09-26 18:50:41
 * @LastEditors: liushumin
-->
<template>
  <el-dialog
    title="取消订单"
    :visible.sync="dialogVisible_order"
    width="30%"
    :before-close="handleClose"
  >
    <el-form
      :model="dynamicValidateForm"
      ref="dynamicValidateForm"
      class="demo-dynamic"
    >
      <el-form-item prop="remarks">
        <el-input
          type="remarks"
          :rows="3"
          placeholder="请输入取消原因，限200字"
          v-model="dynamicValidateForm.remarks"
          maxlength="200"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="stepLoading" @click="getOrders"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["openStatus", "orderId"],
  data() {
    return {
      dynamicValidateForm: {
        remarks: "",
        orderId: "",
      },
      stepLoading: false,
      dialogVisible_order: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_order = this.openStatus;
    },
    orderId(val1, val2) {
      this.dynamicValidateForm.orderId = val1;
    },
  },
  mounted() {
    this.dynamicValidateForm.orderId = this.orderId;
  },
  methods: {
    getOrders() {
      this.dynamicValidateForm.remarks = '';
      this.stepLoading = true;
      this.$http.szOrder.getDelOrder(this.dynamicValidateForm).then((res) => {
        this.stepLoading = false;
        if (res.status == 1) {
          this.$emit("successMark", true);
          this.dialogVisible_order = false;
          this.$emit("closeStatus", true);
          this.$message({
            message: "取消成功",
            type: "success",
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible_order = false;
      this.$emit("closeStatus", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../styles/order-global.scss';
</style>